<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" by-operator :loading="loading"/>
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('operatorTicketsReport.title') }}</h2>
      <p class="text-center mb-3 no-print">
        {{ $t('operatorTicketsReport.description') }}
      </p>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && !error && reportEnvelope" class="row">
      <div class="col-6">
        <card :title="$t('operatorTicketsReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorTicketsReport.summary.operator') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.operatorName }}
                ({{ reportEnvelope.operatorId }})</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorTicketsReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.generatedAt | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorTicketsReport.summary.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.periodFrom | dateOnly }} - {{
                  reportEnvelope.periodTo | dateOnly
                }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorTicketsReport.summary.ticketsPriceSum') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.ticketsPriceSum | money }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorTicketsReport.summary.chargeSum') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.chargeSum | money }}</h5></td>
            </tr>
          </table>
          <div class="alert alert-danger text-center" role="alert"
               v-if="reportEnvelope.ticketsPriceSum !== reportEnvelope.chargeSum">
            <span class="font-weight-bold">{{
                $t('operatorTicketsReport.summary.chargeSumMismatch')
              }}: {{ reportEnvelope.ticketsPriceSum | money }} - {{ reportEnvelope.chargeSum | money }} = {{
                (reportEnvelope.ticketsPriceSum - reportEnvelope.chargeSum) | money
              }} </span>
          </div>
        </card>
      </div>
    </div>

    <div v-if="loading === false && !error && reportEnvelope && reportData" class="row mt-3">
      <div v-if="reportData.length == 0" class="col-12">
        <card class="text-center">
          <div class="places-buttons">
            <div class="row">
              <div class="col-md-6 ml-auto mr-auto text-center">
                <h4 class="card-title">
                  {{ $t('generic.emptyReportForThePeriod') }}
                  <p class="category">
                    {{ $t('generic.emptyReportForThePeriodHelpText') }}
                  </p>
                </h4>
              </div>
            </div>
          </div>
        </card>
      </div>

      <div v-else class="col-12">
        <div v-for="(discount, idx) in reportData" :key="idx" class="row mt-3">
          <div class="col-12">
            <card card-body-classes="table-full-width">
              <h4 slot="header" class="card-title">{{
                  $t(`operatorTicketsReport.discountCard_${discount.discount_id}`)
                }}<small v-if="reportEnvelope"
                         class="ml-2 text-muted">({{ reportEnvelope.periodFrom | dateOnly }} -
                  {{ reportEnvelope.periodTo | dateOnly }})</small>
              </h4>
              <div>
                <el-table :data="discount.fares" show-summary :summary-method="getTicketsTableTotal"
                          :empty-text="$t('generic.noData')">
                  <el-table-column :label="$t('operatorTicketsReport.farePeriod')">
                    <template slot-scope="{ row }">{{ row.started_at | dateOnly }} <span
                      v-if="row.ends_at"> - {{ row.ends_at | dateOnly }}</span></template>
                  </el-table-column>
                  <el-table-column :label="$t('operatorTicketsReport.fareMunicipalityId')">
                    <template slot-scope="{ row }">{{ row.municipality_id }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('operatorTicketsReport.singleTicketPrice')">
                    <template slot-scope="{ row }">{{ row.single_tickets.price | price }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('operatorTicketsReport.singleTicketCount')">
                    <template slot-scope="{ row }">{{ row.single_tickets.count }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('operatorTicketsReport.singleTicketPriceSum')">
                    <template slot-scope="{ row }">{{ row.single_tickets.total_sum | price }}</template>
                  </el-table-column>

                  <!-- monthly tickets -->
                  <el-table-column :label="$t('operatorTicketsReport.monthlyTicketPrice')">
                    <template slot-scope="{ row }">{{ row.monthly_tickets.price | price }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('operatorTicketsReport.monthlyTicketCount')">
                    <template slot-scope="{ row }">{{ row.monthly_tickets.count }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('operatorTicketsReport.monthlyTicketPriceSum')">
                    <template slot-scope="{ row }">{{ row.monthly_tickets.total_sum | price }}</template>
                  </el-table-column>
                </el-table>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert} from 'src/components';
import {mapActions, mapState} from "vuex";
import ReportFilter from "./ReportFilter";

export default {
  name: 'tickets-report',
  components: {
    BaseAlert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ReportFilter
  },
  data() {
    return {
      reportEnvelope: null,
      reportData: [],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.operator_tickets_report.loading,
      data: state => state.operator_tickets_report.data,
      error: state => state.operator_tickets_report.error,
    }),
  },
  methods: {
    ...mapActions(['LoadOperatorTicketsReport']),
    getTicketsTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('operatorTicketsReport.total');
          return;
        }
        if (index === 2 || index === 3 || index === 5 || index === 6) {
          let values;
          if (index === 2) {
            values = data.map(item => Number(item.single_tickets.count));
          } else if (index === 3) {
            values = data.map(item => Number(item.single_tickets.total_sum));
          } else if (index === 5) {
            values = data.map(item => Number(item.monthly_tickets.count));
          } else if (index === 6) {
            values = data.map(item => Number(item.monthly_tickets.total_sum));
          }

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }

          if (index === 3 || index === 6) {
            sums[index] = this.$options.filters['money'](sums[index])
          }

        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    reloadReport(query) {
      this.LoadOperatorTicketsReport(query);
    },
    prepareReportData(data) {
      if (!data) {
        this.reportData = [];
        this.reportEnvelope = null;
        return
      }

      this.reportEnvelope = {
        ticketsPriceSum: 0,
        periodFrom: data.from,
        periodTo: data.to,
        chargeSum: data.charge_sum,
        generatedAt: data.generated_at,
        operatorId: data.operatorId,
        operatorName: data.operatorName,
      }

      if (!data.discounts) {
        return
      }

      let reportData = data.discounts

      // Calculate tickets price sum.
      const sums = reportData.map(function (discount) {
        const totalSinglesSum = discount.fares.reduce(function (prevVal, fare) {
          return prevVal + fare.single_tickets.total_sum
        }, 0)
        const totalMonthlySum = discount.fares.reduce(function (prevVal, fare) {
          return prevVal + fare.monthly_tickets.total_sum
        }, 0)

        return totalSinglesSum + totalMonthlySum;
      })

      this.reportEnvelope.ticketsPriceSum = sums.reduce((a, b) => a + b, 0)
      this.reportData = reportData
    }
  },
  mounted() {
    this.prepareReportData(this.data)
  },
  watch: {
    data(data) {
      this.prepareReportData(data)
    },
  }
};
</script>

